'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var tooltip = require('../components/tooltip.js');
var accordion = require('../components/accordion.js');

basePage.init = function() {
	basePage.initBasePage();

	var $context = $('#modelSelectorPage');
	tooltip.init($context);
	accordion.init();
};

module.exports = basePage; 